export default __webpack_public_path__ + "static/media/holster.24da6e32.png";